import type { ParsedUrlQuery } from 'querystring'
import { Trans } from 'react-i18next'
import { Typography } from '@mui/material'
import NextLink from 'next/link'
import { useRouter } from 'next/router'
import { Link } from 'settle-ui/components/Link/Link'
import { RouterPage } from 'lib/navigation/consts'
import { logEvent } from 'lib/tracking/segment'
import * as events from './LogInLink.events'

interface LogInLinkProps {
  query?: ParsedUrlQuery
  eventContext?: Record<string, unknown>
}

export const LogInLink: Settle.FC<LogInLinkProps> = ({ eventContext, query, ...props }) => {
  const router = useRouter()
  const handleClick = () => logEvent(events.CLICK, { eventContext })

  return (
    <Typography variant="body2" {...props}>
      <Trans
        i18nKey="logInLink"
        components={{
          logIn: (
            <Link
              variant="inherit"
              component={NextLink}
              onClick={handleClick}
              data-testid="log-in-link"
              href={{
                query: query ?? router.query,
                pathname: RouterPage.login,
              }}
            />
          ),
        }}
      />
    </Typography>
  )
}
